import { render, staticRenderFns } from "./PaylasimCard.vue?vue&type=template&id=a2965efe&scoped=true&"
import script from "./PaylasimCard.vue?vue&type=script&lang=js&"
export * from "./PaylasimCard.vue?vue&type=script&lang=js&"
import style0 from "./PaylasimCard.vue?vue&type=style&index=0&id=a2965efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2965efe",
  null
  
)

export default component.exports